import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';

export const templateMaintenanceWindowGrid = document.createElement('template');

templateMaintenanceWindowGrid.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div class="content">
        <div class="grid">
            <gz-grid-view class="grid-view">
                <div class="header-buttons" slot="grid-header-actions-slot">
                    <gz-button id="addWindow" class="mr-1"></gz-button>
                    <gz-button type="outline" color="negative" id="deleteWindow"></gz-button>
                </div>
            </gz-grid-view>
        </div>
    </div>
  </div>
`;
